import { useCallback, useState } from 'react';

export const useImageSizeState = ({
  logger, handleUsage,
}) => {
  const [minWidthFilter, setMinWidthFilter] = useState(null);
  const [minHeightFilter, setMinHeightFilter] = useState(null);

  const onImageSizeFilterChange = useCallback(({ newMinWidth, newMinHeight }) => {
    if (newMinWidth !== minWidthFilter) {
      logger.logTrace('onImageSizeFilterChange', { minWidth: newMinWidth });
      setMinWidthFilter(newMinWidth);
      if (handleUsage) {
        handleUsage();
      }
    }
    if (newMinHeight !== minHeightFilter) {
      logger.logTrace('onImageSizeFilterChange', { minHeight: newMinHeight });
      setMinHeightFilter(newMinHeight);
      if (handleUsage) {
        handleUsage();
      }
    }
  }, [handleUsage, logger, minHeightFilter, minWidthFilter]);

  return {
    minWidthFilter,
    minHeightFilter,
    onImageSizeFilterChange,
  };
};
